// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"78194":"4b7c58c9a227ef25","92888":"fbcf59551b7bd39b"}[chunkId] + ".css";
};